import { provideRtkDesignSystem } from '@cloudflare/realtimekit-ui';
import { normalizeThemeHex, pickAccessibleForeground } from './wcagContrast';

const TEXT_MIN_RATIO = 4.5;

/**
 * RealtimeKit expects `background` as a shade map; each slot uses the same API `headerBackground` hex.
 * @param {string} textHex — resolved text color
 * @param {string | null | undefined} headerBackgroundHex — `headerBackground` as returned
 */
function buildDesignSystemColors(textHex, headerBackgroundHex) {
  const colors = {
    text: textHex,
    'text-on-brand': textHex,
  };
  const bg = normalizeThemeHex(headerBackgroundHex);
  if (bg) {
    colors.background = {
      1000: bg,
      900: bg,
      800: bg,
      700: bg,
      600: bg,
    };
  }
  return colors;
}

/**
 * Applies API `headerColor` / `headerBackground` via `provideRtkDesignSystem`, adjusting text so that
 * foreground and background meet WCAG contrast when a background hex is provided.
 * @param {HTMLElement} meetingHostEl
 * @param {{
 *   preferredTextHex?: string | null,
 *   headerBackground?: string | null,
 *   surfaceBackgroundHex?: string | null,
 * }} [options]
 */
export function ensureRtkMeetingTextContrast(meetingHostEl, options = {}) {
  if (!meetingHostEl || typeof window === 'undefined') return;

  const textHex = normalizeThemeHex(options?.preferredTextHex);
  if (!textHex) return;

  const bgHex =
    normalizeThemeHex(options?.surfaceBackgroundHex ?? options?.headerBackground) ?? null;

  const resolvedTextHex = bgHex
    ? pickAccessibleForeground(bgHex, textHex, { minRatio: TEXT_MIN_RATIO }) ?? textHex
    : textHex;

  provideRtkDesignSystem(meetingHostEl, {
    colors: buildDesignSystemColors(resolvedTextHex, bgHex),
  });
}
